<zendesk-widget
  [attr.user-language]="languageCode()"
  [attr.auth-token]="fdGwToken()"
  [attr.keycloak-environment]="keycloakEnvironment"
  [attr.launcher-position]="'bottom-right'"
/>
